import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GenresService } from '@app/modules/genres-modules/genres.service';

/**
 * Components
 */
import { SearchGenreComponent } from './search-genre/search-genre.component';

/**
 * Vendors
 */
import { TooltipModule } from 'primeng/tooltip';
import { ChipModule } from 'primeng/chip';

@NgModule({
  declarations: [
    SearchGenreComponent
  ],
  exports: [
    SearchGenreComponent
  ],
  entryComponents: [
    SearchGenreComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    ChipModule
  ],
  providers: [
    GenresService
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class GenresModule {}
